// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__hqGtF","sendOtp":"AuthorizeToLogin_sendOtp__1nyHz"};